import type { FaireProductEntity } from "../../entity_types/product";

export const p_fj3m4h5kuw: FaireProductEntity = {
  token: "p_fj3m4h5kuw",
  type: "product",
  name: "Off Leash Set of 10 Pencils",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/98cb600d9fe141c6d9aa7297a074bbdfcc7265ac3dbe80e93df80d2d620661c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/301eca8761f3c7cd5c56f4b531297f1d072d23ddd53ac7ea91e38ccd12b5c0c5.jpeg",
    "https://cdn.faire.com/fastly/17f3ba97b5ad4c0fb64dcb3f8fd1e0be412c5a633832684e111088d4e8518877.jpeg",
    "https://cdn.faire.com/fastly/34841fa5f25d09cdf13ec624c75651efa31ebee43d703dc5e34eef6811321ac8.png",
  ],
  priceDollars: 8,
  description:
    "These pencils are cute, pretty and so good-looking they’re almost desk decorations, coming in an adorable little tube that slides open in the most satisfying way. The designs are fun, the points are sharp - these are sure to give you “new school supplies” butterflies again. If you haven’t used pencils since elementary school, get ready to feel 9 again (arguably with better handwriting). Set of 10 #2 pencils with erasers that actually work. Honestly, we might never use pens again!",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:36.306Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
